import React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { Checkbox } from '../../form/checkbox/checkbox';
import { Button } from '../../form/button/button';
import { IconNext } from '../../icons/next';
import { IconButton } from '../../icon/button/icon-button';
import { BaseDialog } from '../../../web/dialogs/base-dialog';
import { IconPreferences } from '../../icons/preferences';
import { routes } from '../../../../config/routes';
import { useRootStore } from '../../../../providers/root-store-provider';

export const TermsAgreementDialog: React.FC = observer(() => {
    const { t } = useTranslation();
    const { termsAgreementDialogStore } = useRootStore();

    return (
        <BaseDialog
            opened={termsAgreementDialogStore.isOpened}
            close={() => termsAgreementDialogStore.closeDialog()}
            showCloseButton={false}
            icon={<IconButton icon={<IconPreferences />} size={'large'} variant={'primary'} />}
            title={
                <Trans
                    i18nKey={'dialogs.termsAgreement.title'}
                    components={{
                        br: <br />,
                    }}
                />
            }
            width={60}
            content={
                <>
                    <div className="mb-small rounded-large border-[0.1rem] border-border p-medium [&_p]:m-0 [&_p]:text-xlarge [&_p]:text-text [&_p+p]:mt-medium">
                        <p>{t('dialogs.termsAgreement.perex')}</p>
                        <p>
                            <Trans
                                i18nKey={'dialogs.termsAgreement.info'}
                                components={{
                                    strong: <strong />,
                                }}
                            />
                        </p>
                    </div>
                    <div className="flex justify-center [&_label]:mr-0 [&_a]:text-text [&_a]:underline">
                        <Checkbox
                            label={
                                <>
                                    <Trans
                                        i18nKey={'layout.forms.common.agreeTerms'}
                                        components={{
                                            terms: (
                                                <a
                                                    href={routes.web.termsAndConditions}
                                                    target={'_blank'}
                                                    rel="noreferrer"
                                                >
                                                    Link
                                                </a>
                                            ),
                                            privacy: (
                                                <a href={routes.web.privacyPolicy} target={'_blank'} rel="noreferrer">
                                                    Link
                                                </a>
                                            ),
                                        }}
                                    />
                                </>
                            }
                            onChange={() => termsAgreementDialogStore.switchIsCheckboxChecked()}
                            checked={termsAgreementDialogStore.isCheckboxChecked}
                        />
                    </div>
                </>
            }
            action={
                <Button
                    variant="primary"
                    size="vlarge"
                    icon={<IconNext />}
                    disabled={!termsAgreementDialogStore.isCheckboxChecked}
                    block
                    onClick={async () => {
                        termsAgreementDialogStore.confirmTerms();
                    }}
                    loading={termsAgreementDialogStore.confirmLoading}
                >
                    {t('dialogs.termsAgreement.button.submit')}
                </Button>
            }
        />
    );
});
